import { type ICompanyDetailQuery } from 'application/querySchemas/ICompanyDetailQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type ICompanyDetailClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/ICompanyDetailClient';
import {
    type ICompanyDetailForAgentClient,
    IGetResponse as ICompanyDetailForAgentResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyDetailForAgentClient';
import {
    type IBuyerDetailForAgentClient,
    IGetResponse as IBuyerDetailForAgentResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerDetailForAgentClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyDetailQuery implements ICompanyDetailQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly token: IAgentUserTokenRepository,
        @inject('ICompanyDetailClient')
        public readonly companyDetailClient: ICompanyDetailClient,
        @inject('ICompanyDetailForAgentClient')
        public readonly companyDetailForAgentClient: ICompanyDetailForAgentClient,
        @inject('IBuyerDetailForAgentClient')
        public readonly buyerDetailForAgentClient: IBuyerDetailForAgentClient,
    ) {}

    public async fetch(companyId: number): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyDetailClient.get({
            token: this.token.get() || '',
            companyId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchDetail(companyId: number): Promise<ICompanyDetailForAgentResponse['data']> {
        const { data, message } = await this.companyDetailForAgentClient.get({
            token: this.token.get() || '',
            companyId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchBuyerDetail(buyerId: number): Promise<IBuyerDetailForAgentResponse['data']> {
        const { data, message } = await this.buyerDetailForAgentClient.get({
            token: this.token.get() || '',
            buyerId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
